import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import BoxContent from "shared/ui/BoxContent";
import GenericButton from "shared/ui/GenericButton";
import PageTitle from "shared/ui/PageTitle";
import TestItemCard from "../../../../shared/ui/TestItemCard";
import React from "react";

const TestPreviewCustom = ({ items, removeCustomItemHandler }: any) => {
    return (
        <Box width="100%">
            <>
                <PageTitle>Previzualizare test</PageTitle>
                {items.length === 0 ? (
                    <Typography>Nu sunt itemi</Typography>
                ) : (
                    <>
                        {items.map((item: any, index: any) => (
                            <Box mt={3} mb={3} width="100%" key={index}>
                                <BoxContent>
                                    <Box width="100%" display="flex" justifyContent="end">
                                        <GenericButton
                                            type="delete-from-test"
                                            onClick={() => {
                                                removeCustomItemHandler(item);
                                            }}
                                        />
                                    </Box>
                                    <TestItemCard
                                        testMode={7}
                                        key={item.id}
                                        question={item}
                                        isCustomItemPreview={false}
                                        isCustomItemPreviewTest={true}
                                        isAnswerReport={false}
                                        isPrinting={false}
                                        hasBg={true}
                                    />
                                </BoxContent>
                            </Box>
                        ))}
                    </>
                )}
            </>
        </Box>
    );
};

export default TestPreviewCustom;
